import limitdecimal from "./limitdecimal";
import debounceClick from "./debounceClick";
import showtip from "./showtip";
import showellipsistip from "./showellipsistip";
import preventReClick from "./preventReClick";
// 自定义指令
const directives = {
  limitdecimal,
  showtip,
  showellipsistip,
  debounceClick,
  preventReClick
};

export default {
  install(Vue) {
    Object.keys(directives).forEach(key => {
      Vue.directive(key, directives[key]);
    });
  }
};
